<template>
  <transition
    :name="transitionClassName"
    appear
  >
    <slot
      name="content"
    />
  </transition>
</template>

<script>
export default {
  name: 'OwalTransitionSlide',
  props: {
    from: {
      type: String,
      default: 'left',
      validation (newValue) {
        let values = ['top', 'right', 'bottom', 'left']

        return values.includes(newValue)
      },
    },
    /**
     * Determines if the "hide" transition plays in reverse, or continues in the same direction.
     */
    reverses: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    transitionClassName () {
      return `slide-${this.axis}-from-${this.from}${this.reverses ? '-reverse' : ''}`
    },
    axis () {
      if (['top', 'bottom'].includes(this.from)) {
        return 'vertical'
      }
      return 'horizontal'
    },
  },
}
</script>

<style scoped>

/** Slide in from left - slide out to right */
.slide-horizontal-from-left-enter-active,
.slide-horizontal-from-left-reverse-enter-active,
.slide-horizontal-from-right-reverse-leave-active,
.slide-horizontal-from-right-reverse-leave-to {
  animation: slide-in-horizontal 300ms ease;
}

.slide-horizontal-from-left-leave-active,
.slide-horizontal-from-left-leave-to {
  animation: slide-out-horizontal 300ms ease;
}

/** Slide in from right - slide out to left */
.slide-horizontal-from-right-enter-active,
.slide-horizontal-from-right-reverse-enter-active,
.slide-horizontal-from-left-reverse-leave-active,
.slide-horizontal-from-left-reverse-leave-to {
  animation: slide-in-horizontal 300ms ease reverse;
}

.slide-horizontal-from-right-leave-active,
.slide-horizontal-from-right-leave-to, {
  animation: slide-out-horizontal 300ms ease reverse;
}

/** Slide in from top - slide out to bottom */
.slide-vertical-from-top-enter-active,
.slide-vertical-from-top-reverse-enter-active,
.slide-vertical-from-bottom-reverse-leave-active,
.slide-vertical-from-bottom-reverse-leave-to {
  animation: slide-in-vertical 300ms ease;
}

.slide-vertical-from-top-leave-active,
.slide-vertical-from-top-leave-to {
  animation: slide-out-vertical 300ms ease;
}

/** Slide in from bottom - slide out to top */
.slide-vertical-from-bottom-enter-active,
.slide-vertical-from-bottom-reverse-enter-active,
.slide-vertical-from-top-reverse-leave-active,
.slide-vertical-from-top-reverse-leave-to {
  animation: slide-in-vertical 300ms ease reverse;
}

.slide-vertical-from-bottom-leave-active,
.slide-vertical-from-bottom-leave-to {
  animation: slide-out-vertical 300ms reverse;
}

/* --- Slide In Animation --- */

@keyframes slide-in-vertical {
  0% {
    opacity: 0;
    transform: translateY(-16rem) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: initial;
  }
}

@keyframes slide-out-vertical {
  0% {
    opacity: 1;
    transform: initial;
  }
  100% {
    opacity: 0;
    transform: translateY(16rem) scale(0.95);
  }
}

@keyframes slide-in-horizontal {
  0% {
    opacity: 0;
    transform: translateX(-16rem) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: initial;
  }
}

@keyframes slide-out-horizontal {
  0% {
    opacity: 1;
    transform: initial;
  }
  100% {
    opacity: 0;
    transform: translateX(16rem) scale(0.95);
  }
}

</style>
